import styled from 'styled-components';
import { COLORS, FONT_FAMILY, FONTS, size } from 'utils/styles';

export const WarningModalWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 70px;
  margin: 0 auto;
  z-index: 200;
  width: 980px;
  height: 216px;
  background: ${COLORS.whiteShadow};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 20px;
  box-shadow: 0px -7px 22px rgba(0, 0, 0, 0.1), 6px 7px 22px rgba(0, 0, 0, 0.1);

  @media only screen and (max-width: ${size.laptopL}) {
    width: 622px;
    height: 162px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    width: 368px;
    height: 213px;
  }

  @media only screen and (max-width: ${size.mobileL}) {
    width: 286px;
    height: 160px;
  }
`;

export const WarningModalCloser = styled.img`
  position: absolute;
  right: 30px;
  top: 24px;
  cursor: pointer;

  @media only screen and (max-width: ${size.laptopL}) {
    width: 18px;
    height: 18px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    width: 12px;
    height: 12px;
  }
`;

export const WarningModalText = styled.span`
  color: ${COLORS.mainColor};
  ${FONTS.font24};
  ${FONT_FAMILY.FontMedium};

  @media only screen and (max-width: ${size.laptopL}) {
    ${FONTS.font18};
  }

  @media only screen and (max-width: ${size.tablet}) {
    ${FONTS.font16};
    width: 300px;
    text-align: center;
  }

  @media only screen and (max-width: ${size.mobileL}) {
    width: 200px;
    ${FONTS.font14};
  }
`;

export const WarningModalButton = styled.button`
  width: 218px;
  height: 54px;
  background: ${COLORS.mainColor};
  color: ${COLORS.white};
  ${FONTS.font18};
  ${FONT_FAMILY.FontRegular};
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: ${COLORS.mainColor_op7};
  }

  @media only screen and (max-width: ${size.laptopL}) {
    ${FONTS.font16};
  }

  @media only screen and (max-width: ${size.mobileL}) {
    width: 200px;
    ${FONTS.font14};
  }
`;
